import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import { getUBSs, toggleUBSStatus } from "../../api/apiService";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  CircularProgress,
  Alert,
  Switch,
  FormControlLabel,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

const ListarUBS = () => {
  const [ubsList, setUbsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingAction, setLoadingAction] = useState(false); // 🔹 Estado para loading de ações
  const [error, setError] = useState("");
  const [showActive, setShowActive] = useState(true); // 🔹 Alterna entre ativos e inativos

  // Função para carregar UBSs com base no status selecionado (ativo ou inativo)
  const fetchUBS = async (ativo) => {
    setLoading(true);
    setError("");

    try {
      const response = await getUBSs(ativo);
      setUbsList(response);
    } catch (err) {
      setError("Erro ao carregar a lista de UBS.");
    } finally {
      setLoading(false);
    }
  };

  // Alterna entre listar UBSs ativas ou inativas e busca os novos dados corretamente
  const handleToggleStatusView = () => {
    setShowActive((prev) => !prev);
  };

  // Função para ativar/desativar uma UBS com loading durante a ação
  const handleToggleStatus = async (id) => {
    setLoadingAction(true);

    try {
      await toggleUBSStatus(id);
      await fetchUBS(showActive); // 🔹 Recarrega a lista após a alteração
    } catch (err) {
      setError("Erro ao alterar o status da UBS.");
    } finally {
      setLoadingAction(false);
    }
  };

  // Carrega os dados na primeira vez que o componente for montado
  useEffect(() => {
    fetchUBS(showActive);
  }, [showActive]); // 🔹 Atualiza a lista quando mudar entre ativos/inativos

  return (
    <Box
      sx={{ bgcolor: "#f5f5f5", minHeight: "100vh", p: 4, marginTop: "7vh" }}
    >
      <Navbar />
      <Box
        sx={{
          bgcolor: "#fff",
          borderRadius: 2,
          p: 4,
          boxShadow: 3,
          maxWidth: "1000px",
          mx: "auto",
        }}
      >
        <Typography variant="h5" gutterBottom>
          Lista de UBS
        </Typography>

        {error && <Alert severity="error">{error}</Alert>}

        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={2}
        >
          {/* Toggle Switch para alternar entre Ativos/Inativos */}
          <FormControlLabel
            control={
              <Switch checked={showActive} onChange={handleToggleStatusView} />
            }
            label={showActive ? "Mostrando Ativos" : "Mostrando Inativos"}
          />

          <Button
            variant="contained"
            color="primary"
            onClick={() => fetchUBS(showActive)}
            startIcon={<RefreshIcon />}
            disabled={loading} // 🔹 Evita clique enquanto carrega
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Atualizar Lista"
            )}
          </Button>
        </Box>

        {loading ? (
          <Box display="flex" justifyContent="center" mt={3}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <b>Nome</b>
                  </TableCell>
                  <TableCell>
                    <b>Telefone</b>
                  </TableCell>
                  <TableCell>
                    <b>Endereço</b>
                  </TableCell>
                  <TableCell>
                    <b>Ações</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ubsList.length > 0 ? (
                  ubsList.map((ubs) => (
                    <TableRow key={ubs.id}>
                      <TableCell>{ubs.nome}</TableCell>
                      <TableCell>{ubs.telefone || "Não informado"}</TableCell>
                      <TableCell>
                        {ubs.endereco.endereco}, {ubs.endereco.numero}
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color={ubs.ativo ? "error" : "success"}
                          onClick={() => handleToggleStatus(ubs.id)}
                          disabled={loadingAction} // 🔹 Desativa botões enquanto carrega ação
                        >
                          {loadingAction ? (
                            <CircularProgress size={20} color="inherit" />
                          ) : ubs.ativo ? (
                            "Desativar"
                          ) : (
                            "Ativar"
                          )}
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      Nenhuma UBS encontrada.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Box>
  );
};

export default ListarUBS;
